import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';

export class CapacityRange extends DataModel {
  static readonly TYPE_ID: string = 'a92d5163af934e2e8ce74cf9820eeae4';

  private constructor(
    public readonly from: number,
    public readonly to: number,
  ) {
    super();
  }

  get isExact(): boolean {
    return this.from === this.to;
  }

  get $typeId(): string {
    return CapacityRange.TYPE_ID;
  }

  static between(from: number, to: number): CapacityRange {
    return new CapacityRange(from, to);
  }

  static upTo(value: number): CapacityRange {
    return new CapacityRange(1, value);
  }

  static fromMap(context: SerializationContext, map: SerializedData): CapacityRange {
    return new CapacityRange(
        MapUtils.get<number>(map, 'from'),
        MapUtils.get<number>(map, 'to'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'from': this.from,
      'to': this.to,
    };
  }

  clone(): this {
    return new CapacityRange(
        this.from,
        this.to,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.from === this.from &&
        other.to === this.to;
  }

  toDiagnosticsObject(): SerializedData {
    return {
      'from': this.from,
      'to': this.to,
    };
  }
}

export class CapacityRangeBuilder extends DataModelBuilder<CapacityRange> {
  build(context: SerializationContext, map: SerializedData): CapacityRange {
    return CapacityRange.fromMap(context, map);
  }
}
